import React from "react";

import { eventSurveyBadge, widgetSurveyBadge } from "constants/getBadgeTypes";

const BadgeIcon = ({ badge: badgeKey, points: customPoints, size = "medium" }) => {
  const badge = badgeKey === "event_survey" ? eventSurveyBadge : widgetSurveyBadge;
  const points = customPoints || badge.points;

  return (
    <div className={`BadgeIcon ${size}`}>
      <img src={badge.image} alt={badge.description} />
      {points > 0 && (
        <div className="points">
          <span>+{points}</span>
        </div>
      )}
    </div>
  );
};

export default BadgeIcon;
